import React from 'react';
import './DashboardTaskbarBody.css';
import DashboardTaskbarBodyTab from "../DashboardBodyTabs/DashboardTaskbarBodytTabs";
import descriptionDetails from './DashboardDescription'

const DasboardTaskbarBrainBody = () => {
    return (
        <div className="dashboardtaskbarbody">
            {/* <DashboardTaskbarBodyTab header="Youtube Video Description" body={descriptionDetails.Youtube_Video_Description} /> */}
            {/* <DashboardTaskbarBodyTab header="Ad Ideas" body={descriptionDetails.Ad_ideas} /> */}
            {/* <DashboardTaskbarBodyTab header="AIDA Framework" body={descriptionDetails.AIDA_framework} /> */}
            <DashboardTaskbarBodyTab link="/generate/Faq" header="FAQ Ideas" body={descriptionDetails.FAQ_Ideas} />
            {/* <DashboardTaskbarBodyTab header="Captions" body={descriptionDetails.Captions} /> */}
            {/* <DashboardTaskbarBodyTab header="Content Ideas" body={descriptionDetails.Content_Ideas} /> */}
            {/* <DashboardTaskbarBodyTab header="Listicle" body={descriptionDetails.Listicle} /> */}
            <DashboardTaskbarBodyTab link="/generate/PainAgitate" header="Pain Benefit Solution" body={descriptionDetails.Pain_Benefit_Solution} />
        </div>
    )
}

export default DasboardTaskbarBrainBody;